import { useEffect } from "react";
import { asList, useCatalogQuery, useDiscountedProducts } from "./useProductsBySubCategory";

// slugs look like "<name>_<id>"
const subcategoryIdFromSlug = (slug) => slug.split("_")[1];

export const useFetchSubSubcategories = (slug) => {
  const { data } = useCatalogQuery("/public/sub-subcategories", {
    params: { sub_category: subcategoryIdFromSlug(slug) },
    transform: asList,
  });

  return data ?? [];
};

export const useFetchSubcategoryAttributes = (slug) => {
  const { data } = useCatalogQuery("/public/attr", {
    params: { subcategory: subcategoryIdFromSlug(slug) },
  });

  return data ?? [];
}

export const useFetchSubcategories = (slug) => {
  const { data, loading } = useCatalogQuery(`/public/subcategories/${subcategoryIdFromSlug(slug)}`);

  useEffect(() => {
    if (data?.name) document.title = data.name + " - Desi Fresh";
  }, [data?.name]);

  return [data ?? {}, loading];
}

// same cache entry as the landing page's "Discounts & Offers" slider
export const useFetchDiscountedProducts = () => {
  const { products, loading } = useDiscountedProducts();
  return [products, loading];
}

const EMPTY_FILTER_OPTIONS = {
  discounts_and_offer_count: 0,
  brands: [],
};

export const useFetchDesktopFiltersState = (slug) => {
  const { data, loading } = useCatalogQuery("/public/products/filters/get-options", {
    params: { sub_category: subcategoryIdFromSlug(slug) },
    transform: (data) => ({
      discounts_and_offer_count: data.discounts_and_offer_count,
      brands: data.brands,
    }),
  });

  return [data ?? EMPTY_FILTER_OPTIONS, loading];
}

export const useFetchCategories = (id) => {
  const { data, loading } = useCatalogQuery(`/public/categories/${id}`, { enabled: !!id });

  return [data ?? {}, loading];
}
